export default {
  home: 'Home',
  login: 'Login',
  components: 'Components',
  count_to_page: 'Count-to',
  tables_page: 'Table',
  split_pane_page: 'Split-pane',
  markdown_page: 'Markdown-editor',
  editor_page: 'Rich-Text-Editor',
  icons_page: 'Custom-icon',
  img_cropper_page: 'Image-editor',
  update: 'Update',
  doc: 'Document',
  join_page: 'QQ Group',
  update_table_page: 'Update .CSV',
  update_paste_page: 'Paste Table Data',
  multilevel: 'multilevel',
  directive_page: 'Directive',
  level_1: 'Level-1',
  level_2: 'Level-2',
  level_2_1: 'Level-2-1',
  level_2_3: 'Level-2-3',
  level_2_2: 'Level-2-2',
  level_2_2_1: 'Level-2-2-1',
  level_2_2_2: 'Level-2-2-2',
  excel: 'Excel',
  'upload-excel': 'Upload Excel',
  'export-excel': 'Export Excel',
  tools_methods_page: 'Tools Methods',
  drag_list_page: 'Drag-list',
  i18n_page: 'Internationalization',
  modalTitle: 'Modal Title',
  content: 'This is the modal box content.',
  buttonText: 'Show Modal',
  'i18n-tip': 'Note: Only this page is multi-language, other pages do not add language content to the multi-language package.',
  error_store_page: 'Error Collection',
  error_logger_page: 'Error Logger',
  query: 'Query',
  params: 'Params',
  cropper_page: 'Cropper',
  message_page: 'Message Center',
  tree_table_page: 'Tree Table',
  org_tree_page: 'Org Tree',
  drag_drawer_page: 'Draggable Drawer',
  tree_select_page: 'Tree Selector',
  user: 'Account',
  role: 'Role',
  permission: 'Permission',
  customer: 'Customer',
  factory: 'Factory',
  device: 'Device',
  order: 'Order',
  batch: 'Batch',
  piece: 'Piece',
  event: 'Event',
  customer_user: 'Customer User',
  remark: 'Remark',
  finance: 'Finance',
  customer_user: '客户用户',
  remark: '备注管理',
  finance: '财务管理',
  dy: '运营后台',
  org_confg: '基础配置',
  gpt_library: 'gpt话术库',
  classify_library: '分类库',
  action_type_library: '动作类型库',
  task_type_library: '任务类型库',
  holiday_library: '节假日祝福语',
  strategy: '运营策略',
  gpt: 'gpt配置',
  advertisement: '广告语配置',
  org: '固定话术配置',
  comment_strategy_rule: '评论私信策略',
  letter_strategy: '私信周期策略',
  comment_strategy: '标题关键词',
  comment_strategy_keyword: '评论关键词',
  strategy_task: '运营任务',
  strategy_result: '运营结果',
  dy_user_list: '运营账号列表',
  strategy_result_chart: '运营结果统计',
  strategy_result_list: '评论记录',
  customer_classify_list: '客户分类列表',
  tag_stand: '用户画像话术',
  tag: '用户画像类别',
  flower: '关注人',
  flower: '关注人',
  children_comment: '子信息',
  push_video: '发布视频',
  delete_comment_list: '被删除的评论',
  video_audio_manage: '音视频管理',
  char2Audio: '语音生成',
  start_video_task: '启动短视频',
  check_srt: '提取字幕',
  translate_text: '翻译文本',
  covert_face_list: '视频生成',
  merge_video: '合成视频',
  translate_detail: '翻译校对界面',
  check_srt_form: '话术校对界面',
  advertisement_video: '插入广告',
  stand_user: '对标账号'
}
